<template>
  <div class="store-locator__list">
    <div
      :id="store.uid"
      :class="[{ active: isActive === store.uid }]"
      v-for="(store, index) in stores"
      :key="store.uid"
      @click.native.capture="clickStore(store)"
      :is="cardComponent"
      :store="store"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'cp-list',
  props: {
    // @TODO - Allow to display stores grouped (stores structure or by key value)
    // @TODO - group = true/false or 'key'
    // group: {
    //     default() {
    //         return null;
    //     },
    //     type: [Boolean, Function, String],
    // },
    options: {
      required: true,
      type: Object,
    },
    stores: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  data() {
    return {
      cardComponent: 'cp-card',
      isActive: null,
    };
  },
  methods: {
    clickStore(store) {
      this.$bus.emit('disable-marker');
      this.$bus.emit('active-marker', store.uid);
      this.$bus.emit('center-map', store.lat, store.lng, 15);
    },

    activeStore(uid) {
      this.isActive = uid;

      // Scroll to the activated store
      const scrollTo = (element, to, duration) => {
        if (duration <= 0) {
          return;
        }

        let difference = to - element.scrollTop;
        let perTick = (difference / duration) * 10;

        setTimeout(() => {
          element.scrollTop = element.scrollTop + perTick;
          if (element.scrollTop === to) {
            return;
          }
          scrollTo(element, to, duration - 10);
        }, 10);
      };

      // scrollTo(
      //     document.querySelector(`.store-locator__list`),
      //     document.querySelector(`#${uid}`).offsetTop - 90,
      //     300
      // );

      // window.scrollTo({
      //   behavior: 'smooth',
      //   left: 0,
      //   top: document.querySelector('.store-locator__map').offsetTop,
      // });
    },
  },
  mounted() {
    this.trace('{list.vue} mounted');

    this.$bus.on('active-marker', (uid) => this.activeStore(uid));
    this.$bus.on('disable-marker', () => (this.isActive = null));
  },
};
</script>
